// Example starter JavaScript for disabling form submissions if there are invalid fields
const form = (function (window, jQuery) {
	"use strict";

	window.addEventListener(
		"load",
		function () {
			// Fetch all the forms we want to apply custom Bootstrap validation styles to
			var forms = Array.from(
				document.getElementsByClassName("needs-validation")
			);

			// Loop over them and prevent submission
			forms.filter((frm) => {
				frm.addEventListener(
					"submit",
					function (event) {
						if (frm.checkValidity() === false) {
							event.preventDefault();
							event.stopPropagation();
						}
						frm.classList.add("was-validated");
					},
					false
				);
			});

			// address
			jQuery("[data-mapped-fields]").on("change, click", function () {
				let input = jQuery(this);

				let confirmationCheck = input.data("confirmation-check");
				let confirmationUncheck = input.data("confirmation-uncheck");

				let mappingsJson = input.data("mapped-fields");
				let mappingJsonKeys = Object.keys(mappingsJson);

				if (input.is(":checked")) {
					if (
						isAnyMappedFieldSet(mappingsJson, mappingJsonKeys) &&
						(!confirmationCheck || !window.confirm(confirmationCheck))
					) {
						input.prop("checked", false);
						return;
					}

					for (let key of mappingJsonKeys) {
						let mappedField = mappingsJson[key];
						let origField = jQuery("#" + key);
						let origVal = origField.val();
						let mappedInput = jQuery("#" + mappedField);
						mappedInput.val(origVal);
						mappedInput.prop("readonly", true);

						origField.on("keyup change", (e) => {
							mappedInput.val(e.target.value);
						});
					}
				} else {
					let deleteFields = true;
					if (isAnyMappedFieldSet(mappingsJson, mappingJsonKeys) &&
						(!confirmationUncheck || !window.confirm(confirmationUncheck))
					) {
						deleteFields = false;
					}

					for (let key of mappingJsonKeys) {
						let mappedField = mappingsJson[key];
						let origField = jQuery("#" + key);

						let mappedInput = jQuery("#" + mappedField);

						if (deleteFields) {
							mappedInput.val("");
						}
						mappedInput.prop("readonly", false);

						origField.off("keyup change");
					}
				}

				function isAnyMappedFieldSet(mappings, mappingKeys) {
					let isSet = false;
					for (let key of mappingKeys) {
						let mappedField = mappings[key];

						let mappedInput = jQuery("#" + mappedField);
						isSet = mappedInput.val() !== "";

						if (isSet) { break; }
					}

					return isSet;
				}
			});


			let isDataTransferSupported = () => {
				//add delete button to each <figure> if supported
				let dataTransferSupported = false;
				try {
					let x = new DataTransfer();
					dataTransferSupported = true;
				}
				catch (ex) {
					dataTransferSupported = false;
				}
				return dataTransferSupported;
			};

			let renderSelectedFiles = ($input, $label, $imageGrid, files, config, onDeleteFile) => {
				let defaultConfig = {
					fileTitlePlaceholder: $input.data("file-title-placeholder") || 'File Title',
					deleteHint: $input.data("delete-hint") || 'Delete',
					deleteQuestion: $input.data("delete-question") || 'Delete?',
					minFile: ($input.data("min-files") + 0) || 0,
					maxFiles: ($input.data("max-files") + 0) || 0,
					showFileNameInput: $input.data("show-filename-input") === true,
				};

				let cfg = jQuery.extend({}, defaultConfig, config);

				let inputID = $input.attr("id") || $input.attr("name");

				//clear the image Grid
				if ($label) {
					$label.empty();
				}

				$imageGrid.empty();

				//validate num of files
				if (cfg.maxFiles > 0 && cfg.minFiles > 0 && (files.length < cfg.minFiles || files.length > cfg.maxFiles)) {
					$input[0].setCustomValidity(
						`Number of Files is limited to min ${cfg.minFiles} and max ${cfg.maxFiles}.`
					);
				}
				else {
					$input[0].setCustomValidity("");
				}

				let idx = 0;

				//generate files grid
				for (let f of files) {

					f.url = URL.createObjectURL(f);
					f.ext = f.name.split(".").pop();

					if ($label) {
						if (!$label.hasClass("selected")) {
							$label.addClass("selected");
						}

						$label.append(`<span>"${f.name.toLowerCase()}"</span> `);
					}

					let addedImage = null;

					//choose if image or SVG icon element
					if (f.type.indexOf("image/") > -1) {
						addedImage = `<img src="${f.url}" alt="${f.name}" width="80" height="60" />`;
					} else {
						addedImage = `
							<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 511 511" style="enable-background:new 0 0 511 511" xml:space="preserve">
								<path d="M454.962,110.751c-0.018-0.185-0.05-0.365-0.081-0.545c-0.011-0.06-0.016-0.122-0.028-0.182  c-0.043-0.215-0.098-0.425-0.159-0.632c-0.007-0.025-0.012-0.052-0.02-0.077c-0.065-0.213-0.141-0.421-0.224-0.625  c-0.008-0.021-0.015-0.043-0.023-0.064c-0.081-0.195-0.173-0.384-0.269-0.57c-0.016-0.031-0.029-0.063-0.045-0.094  c-0.093-0.173-0.196-0.339-0.301-0.504c-0.027-0.042-0.05-0.086-0.077-0.127c-0.103-0.154-0.216-0.3-0.33-0.446  c-0.037-0.048-0.07-0.098-0.109-0.145c-0.142-0.173-0.294-0.338-0.45-0.498c-0.015-0.015-0.027-0.031-0.042-0.046l-104-104  c-0.018-0.018-0.038-0.033-0.057-0.051c-0.156-0.153-0.317-0.301-0.486-0.44c-0.055-0.045-0.113-0.083-0.169-0.126  c-0.138-0.107-0.275-0.214-0.42-0.311c-0.051-0.034-0.105-0.062-0.156-0.095c-0.156-0.099-0.312-0.197-0.475-0.284  c-0.036-0.019-0.074-0.035-0.111-0.053c-0.181-0.093-0.365-0.183-0.554-0.262c-0.024-0.01-0.049-0.017-0.074-0.027  c-0.202-0.081-0.406-0.157-0.616-0.221c-0.027-0.008-0.054-0.013-0.081-0.021c-0.206-0.06-0.415-0.115-0.628-0.158  c-0.063-0.013-0.128-0.018-0.192-0.029c-0.177-0.031-0.354-0.062-0.536-0.08C344.001,0.013,343.751,0,343.5,0h-248  C73.72,0,56,17.72,56,39.5v432c0,21.78,17.72,39.5,39.5,39.5h320c21.78,0,39.5-17.72,39.5-39.5v-360  C455,111.249,454.987,110.999,454.962,110.751z M351,25.606L429.394,104H375.5c-13.509,0-24.5-10.99-24.5-24.5V25.606z M415.5,496  h-320C81.991,496,71,485.01,71,471.5v-432C71,25.99,81.991,15,95.5,15H336v64.5c0,21.78,17.72,39.5,39.5,39.5H440v352.5  C440,485.01,429.009,496,415.5,496z"/>

								<text style="font-size:100px;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none;" xml:space="preserve" transform="matrix(1.15,0,0,1.2,0,0)">
									<tspan y="275" x="90">${f.ext || "???"}</tspan>
								</text>
							</svg>
						`;
					}

					let $fileNameInput = cfg.showFileNameInput ?
						`<br /><input type="text" id="${inputID}_filetitle_${idx}" name="${inputID}_filetitle_${idx}" class="form-control-sm" placeholder="${cfg.fileTitlePlaceholder}" />`
						: '';

					//create <figure> element
					let $figure = jQuery(`
						<figure>
							${addedImage}
							<figcaption>
								${f.name} (${(f.size / 1024).toFixed(0)}kB)
								${$fileNameInput}
							</figcaption>
						</figure>
					`);

					//add delete button to each <figure> if supported
					if (isDataTransferSupported()) {
						let $btn = jQuery(`
							<button type="button" data-filename="${f.name}" title="${cfg.deleteHint}">&#10060;</button>
						`);

						//handler for delete <button> click
						$btn.on("click", (e) => {
							e.preventDefault();

							if (confirm(cfg.deleteQuestion)) {
								let flName = $btn.data("filename");
								var dt = new DataTransfer();

								//skip deleted file
								for (let fl of files) {
									if (fl.name === flName) {
										continue;
									}

									dt.items.add(fl);
								}

								files = null;
								files = dt.files;

								if (onDeleteFile) {
									onDeleteFile(flName, files);
								}
								renderSelectedFiles($input, $label, $imageGrid, files, cfg, onDeleteFile);
							}
						});

						$figure.append($btn);
					}



					if (addedImage) {
						$imageGrid.append($figure);
					}

					idx++;
				}
			};

			let createFileFromUrl = async (url) => {
				let response = await fetch(url);

				if (response.status === 200) {
					let data = await response.blob();

					var idx = url.lastIndexOf('/');
					var filename = url.substring(idx + 1);

					let metadata = {
						type: data.type,
						//size: data.size
					};

					let file = new File([data], filename, metadata);

					return file;
				}
				return null;
			};

			// Add the following code if you want the name of the file appear on select
			jQuery(".custom-file-input").on("change", function (e) {
				var input = jQuery(this);
				var label = input.siblings(".custom-file-label");
				var imageGrid = input.siblings(".custom-file-image-grid");

				renderSelectedFiles(input, label, imageGrid, this.files);
			});

			jQuery(".existing-file-input").each(async function (idx, elem) {
				var input = jQuery(this);
				var label = null;
				var imageGrid = input.siblings(".custom-file-image-grid");

				let urls = input.val().split('|');
				let urlsIterable = urls[Symbol.iterator]();
				var dt = new DataTransfer();

				for await (let url of urlsIterable) {
					let f = await createFileFromUrl(url);

					dt.items.add(f);
				}

				renderSelectedFiles(input, label, imageGrid, dt.files, null, (deletedFileName, newFiles) => {
					let currentUrls = input.val().split('|');

					let newUrls = currentUrls.filter(i => ("/" + i.toLowerCase()).lastIndexOf("/" + deletedFileName.toLowerCase()) === -1);

					input.val(newUrls.join("|"));
				});
			});

			jQuery("[data-ares-mapped-fields]").on("click", function (e) {
				var button = jQuery(e.target);
				let aresUrl = button.data("ares-url");
				let aresNotFilledIn = button.data("ares-not-filled-in") || "ID was not filled-in.";
				let aresNotFound = button.data("ares-not-found") || "ID was not found.";
				let aresMappingJson = button.data("ares-mapped-fields");
				let icoField = button.data("ares-id-field");
				let ico = jQuery("#" + icoField).val();

				if (!ico) {
					alert(aresNotFilledIn);
					return;
				}

				if (!aresUrl) {
					console.log("ARES wrapper URL not set.");
					return;
				}

				aresUrl = aresUrl.replace("${id}", ico);

				loadAresData({
					url: aresUrl,
					onFinished: function (data) {
						for (let key in aresMappingJson) {
							let dataKey = aresMappingJson[key];

							let val = data[dataKey];

							let inpt = jQuery("#" + key);
							inpt.val(val);
							inpt.trigger("change");
						}
					},
					onNotFound: function () {
						alert(aresNotFound);
					}
				});

				function loadAresData(options) {
					var defaults = {
						url: '',
						onFinished: null,
						onNotFound: null,
					};

					var opts = jQuery.extend(defaults, options);

					if (!opts.url) {
						console.log("No ARES Url passed to getAresData().");
						return;
					}

					jQuery.get(opts.url, function (data) {
						var xml = jQuery(data);

						if (xml.find('D\\:E').length == 1) {
							if (opts.onNotFound) {
								opts.onNotFound.call(this);
							}
						}
						else {
							if (opts.onFinished) {
								var obj = {};

								obj.aresIdNumber = xml.find('D\\:ICO').html();
								obj.aresVatNumber = xml.find('D\\:DIC').html();
								obj.aresName = xml.find('D\\:OF').html();
								obj.aresCountry = xml.find('D\\:NS').html();
								obj.aresCity = xml.find('D\\:N').html();
								obj.aresCityPart = xml.find('D\\:NCO').html();
								obj.aresStreet = xml.find('D\\:NU').html();
								obj.aresHouseNumber = xml.find('D\\:CD').html();
								obj.aresPostalCode = xml.find('D\\:PSC').html();
								obj.aresFullStreet = obj.aresStreet + ' ' + obj.aresHouseNumber;

								opts.onFinished.call(this, obj);
							}
						}
					});
				}
			});
		},
		false
	);
})(window, jQuery);

export default form;
